export default __webpack_public_path__ + "static/media/army_32.3fa0ed64.jpg";